import { render, staticRenderFns } from "./cancel-instructions.vue?vue&type=template&id=21233845&"
import script from "./cancel-instructions.vue?vue&type=script&lang=js&"
export * from "./cancel-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports